// extracted by mini-css-extract-plugin
export default {"Manage":"style_Manage__nwfNZ","images":"style_images__oEEp7","manage2":"style_manage2__WXNaH","text":"style_text__PG6SK","logoText":"style_logoText__OqoRQ","img":"style_img__6o9uO"};